webpackJsonp([1],{

/***/ "/KV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1CK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("5qMT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078d3afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("yiIV");
function injectStyle (ssrContext) {
  __webpack_require__("lc7O")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-078d3afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078d3afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Dkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TZB_WEB_PUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TZB_MOBILE_PUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COOKIE_DOMAIN; });
var API_URL = "https://api.tzb.cnosfap.net/v1" || 'https://api.cnosfap.net/tzb';
var TZB_WEB_PUB = "https://xl.tzb.cnosfap.net" || 'https://tazebao.cnosfap.net';
var TZB_MOBILE_PUB = "https://m.tzb.cnosfap.net" || 'https://tazebao.cnosfap.net/presenze';

var COOKIE_DOMAIN = ".cnosfap.net" || '.cnosfap.net';

/***/ }),

/***/ "5qMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_auth__ = __webpack_require__("AQL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_avatar__ = __webpack_require__("7e0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_config__ = __webpack_require__("2Dkn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_3__components_avatar__["a" /* default */]
  },
  data: function data() {
    return {
      contact: {},
      tzbPresence: false,
      services: [{
        name: 'tazebao',
        enable: true,
        url: __WEBPACK_IMPORTED_MODULE_4__service_config__["b" /* TZB_WEB_PUB */],
        image: '../../static/tzb-icon.png',
        title: 'Tazebao Desktop',
        subtitle: 'Registro Elettronico e gestione corsi'
      }, {
        name: 'extranet',
        enable: true,
        url: 'http://extranet.cnosfap.net/googleauth.php?info=TzbInfo',
        image: '../../static/m3.png',
        title: 'Extranet',
        subtitle: 'Gestione bollature dipendenti, DB professional'
      }, {
        name: 'organization',
        enable: true,
        url: 'https://sites.google.com/a/cnosfap.net/processicnos/presentazione-dell-associazione',
        image: '../../static/piemonte.png',
        title: 'Sistema Organizzativo',
        subtitle: 'Sistema Qualità e Accreditamento'
      }, {
        name: 'tzbpresence',
        enable: true,
        url: __WEBPACK_IMPORTED_MODULE_4__service_config__["c" /* TZB_MOBILE_PUB */],
        image: '../../static/tzb-presence.png',
        title: 'Presenze rapide',
        subtitle: 'App mobile per rilevamento rapido presenze'
      }, {
        name: 'siq',
        enable: true,
        url: 'http://siq.cnosfap.net/index.php?info=TzbInfo',
        image: '../../static/siq.png',
        title: 'Sistema Informativo Qualità',
        subtitle: 'Archivio anni precedenti al 2019'
      }, {
        name: 'tazebot',
        enable: true,
        url: 'https://t.me/tazebaobot',
        image: '../../static/tazebot.png',
        title: 'Tazebao BOT',
        subtitle: 'Telegram BOT per la comunicazione con le famiglie'
      }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var contact;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* default */].login();

            case 3:
              contact = _context.sent;

              _this.contact = contact;
              if (contact) {
                _this.tzbPresence = contact.userAuth.auth.CoursePresence.rapidPresenceEnable;
              }
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              _this.$router.replace({
                name: 'login',
                query: {
                  message: 'Login fallito.\nCausa: ' + _context.t0.message
                }
              });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },


  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__service_auth__["a" /* default */].logout();
      this.$router.push({
        name: 'login'
      });
    },
    gotoUrl: function gotoUrl(service, url) {
      if (service.enable) {
        if (service.name === 'tzbpresence') {
          if (this.tzbPresence === true) {
            window.location.href = url;
          }
        } else {
          window.location.href = url;
        }
      }
    },
    serviceClass: function serviceClass(service) {
      var style = '';
      if (service.enable) {
        if (service.name === 'tzbpresence') {
          if (this.tzbPresence === true) {
            style = 'enabled';
          } else style = 'disabled';
        } else {
          style = 'enabled';
        }
      } else style = 'disabled';
      return style;
    }
  }
});

/***/ }),

/***/ "6FTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadedThumb),expression:"loadedThumb"}],class:_vm.getClass,style:(_vm.getImgStyle),attrs:{"id":"image","src":_vm.getSrcThumb,"alt":"immagine profilo utente"},on:{"load":_vm.loadedThumbImage}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.2","/app"]],"_from":"axios@0.21.2","_id":"axios@0.21.2","_inBundle":false,"_integrity":"sha512-87otirqUw3e8CzHTMO+/9kh/FSgXt/eVDvipijwDtEuwbkySWZ9SBm6VEubmJ/kLKEoLQV/POhxXFb66bfekfg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.2","name":"axios","escapedName":"axios","rawSpec":"0.21.2","saveSpec":null,"fetchSpec":"0.21.2"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.2.tgz","_spec":"0.21.2","_where":"/app","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.2"}

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"login","version":"1.0.0","description":"A Uniform login page for all cnosfap.net user access","license":"MIT","homepage":"://tazebao.cnosfap.net","private":true,"scripts":{"dev":"cross-env ADDRESS=login.cnosfap.net node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","lint":"eslint --ext .js,.vue src"},"engines":{"node":">= 14.18","npm":">= 6.14"},"contributors":[{"name":"Archimedix","email":"io@archimedix.net","web":"http://archimedix.net"},{"name":"Nena","email":"elena.carniel@cnosfap.net"},{"name":"IceOnFire","email":"antonymistretta@gmail.com","web":"https://www.ingloriouscoderz.it"}],"dependencies":{"axios":"^0.21.2","buefy":"^0.8.17","codice-fiscale-js":"^2.2.4","vue":"^2.4.2","vue-cookie":"^1.1.4","vue-router":"^2.7.0"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.0.1","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^5.2.0","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^4.19.1","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.0.1","eslint-plugin-vue":"^4.5.0","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","rimraf":"^2.6.0","semver":"^5.3.0","shelljs":"^0.8.5","url-loader":"^0.5.8","vue-loader":"^13.0.4","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "7e0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__ = __webpack_require__("HebC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f52472_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__ = __webpack_require__("6FTN");
function injectStyle (ssrContext) {
  __webpack_require__("pGQI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18f52472"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f52472_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AQL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__query__ = __webpack_require__("ZhQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__("lta2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contact__ = __webpack_require__("W3zz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("2Dkn");



var checkAndRedirect = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var _parse, redirectTo, auth, contactIdCookie;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__query__["a" /* parse */])(window.location.search), redirectTo = _parse.redirectTo;

            if (!redirectTo) {
              redirectTo = '#/landing';
            }

            auth = checkAuth();

            if (auth) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return');

          case 5:
            contactIdCookie = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('contactId');
            // console.log('COOKIE_DOMAIN2: ', COOKIE_DOMAIN)

            if (contactIdCookie) {
              _context.next = 16;
              break;
            }

            _context.prev = 7;
            _context.next = 10;
            return login();

          case 10:
            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](7);

            window.location.href = '#/?message=' + _context.t0.message;
            return _context.abrupt('return');

          case 16:
            // console.log('redirectTo:', redirectTo)
            window.location.href = redirectTo;

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[7, 12]]);
  }));

  return function checkAndRedirect() {
    return _ref.apply(this, arguments);
  };
}();

var login = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var accessToken, contactId, _contact, userId, userUrl, userResponse, profile, contactUrl, _ref3, data, contact;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('access_token');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__http__["b" /* authorize */])(accessToken);

            contactId = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('contactId');

            if (!contactId) {
              _context2.next = 8;
              break;
            }

            _context2.next = 6;
            return __WEBPACK_IMPORTED_MODULE_5__contact__["a" /* default */].get(contactId);

          case 6:
            _contact = _context2.sent;
            return _context2.abrupt('return', _contact);

          case 8:
            userId = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('userId');
            userUrl = 'UserIdentities';

            userUrl += '?filter[where][userId]=' + userId;
            _context2.next = 13;
            return __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get(userUrl);

          case 13:
            userResponse = _context2.sent;
            profile = userResponse.data[0].profile;


            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.set('contactEmail', profile.emails[0].value, {
              domain: __WEBPACK_IMPORTED_MODULE_6__config__["d" /* COOKIE_DOMAIN */]
            });

            contactUrl = 'TzbContacts';

            contactUrl += '?filter[where][_emails.email]=' + profile.emails[0].value;
            _context2.next = 20;
            return __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get(contactUrl);

          case 20:
            _ref3 = _context2.sent;
            data = _ref3.data;

            if (data.length) {
              _context2.next = 24;
              break;
            }

            throw new Error('Contatto non trovato.');

          case 24:
            contactId = data[0].id;
            _context2.next = 27;
            return __WEBPACK_IMPORTED_MODULE_5__contact__["a" /* default */].get(contactId);

          case 27:
            contact = _context2.sent;

            /*
            const [contactPreferences] = await Contact.getPreferences({ contactId })
            contact.contactPreferences = contactPreferences
             const yearId = contact.contactPreferences.defaultYear.id
            const schoolId = contact.contactPreferences.defaultSchool.id
             const [userAuth] = await Contact.getAuths({ contactId, yearId, schoolId })
            contact.userAuth = userAuth */

            if (profile.provider === 'google') {
              contact.gImage = profile.photos[0].value;
            }
            ids.forEach(function (id) {
              return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.set(id, contact[id === 'contactId' ? 'id' : id], {
                domain: __WEBPACK_IMPORTED_MODULE_6__config__["d" /* COOKIE_DOMAIN */]
              });
            });
            return _context2.abrupt('return', contact);

          case 31:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function login() {
    return _ref2.apply(this, arguments);
  };
}();







// console.log('COOKIE_DOMAIN: ', COOKIE_DOMAIN)
/* harmony default export */ __webpack_exports__["a"] = ({ checkAndRedirect: checkAndRedirect, check: checkAuth, login: login, logout: logout });

var ids = ['contactId', 'siqPersonaleId', 'extraPersonaleId', 'lastName', 'firstName'];

var COOKIES = [].concat(ids, ['access_token', 'userId', 'contactEmail']);

function checkAuth() {
  var accessTokenCookie = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('access_token');
  var userIdCookie = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('userId');
  return accessTokenCookie && userIdCookie;
}

function logout() {
  COOKIES.forEach(function (id) {
    return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.delete(id, { domain: __WEBPACK_IMPORTED_MODULE_6__config__["d" /* COOKIE_DOMAIN */] });
  });
  return null;
}

/***/ }),

/***/ "HebC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contactAvatar',
  props: {
    contactId: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 50
    },
    borderRadius: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      contactID: '',
      imageThumb: '',
      loadedThumb: false,
      currentClass: 'img-visible'
    };
  },
  created: function created() {
    if (this.contactId) {
      this.contactID = this.contactId;
    }
  },
  mounted: function mounted() {
    if (this.contactID) {
      this.setImageUrl();
    }
  },

  watch: {
    contactId: function contactId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.contactID = newId;
        this.setImageUrl();
      }
    }
  },
  computed: {
    getSrcThumb: function getSrcThumb() {
      var thumb = this.imageThumb ? 'data:image/png;base64,' + this.imageThumb : '';
      return thumb;
    },
    getImgStyle: function getImgStyle() {
      var styleString = 'width:' + this.width + 'px;height:' + this.height + 'px;';
      if (this.borderRadius) {
        styleString += 'border-radius:' + this.borderRadius + 'px;';
      }
      return styleString;
    },
    getClass: function getClass() {
      return this.currentClass;
    }
  },
  methods: {
    loadedThumbImage: function loadedThumbImage() {
      this.loadedThumb = true;
    },
    setImageUrl: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var thumbFromDb, whereForQuery, fieldsForQuery, filter, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadedThumb = false;
                thumbFromDb = void 0;
                whereForQuery = {
                  docType: 'profileImage',
                  'ref.contactId': this.contactID
                };
                fieldsForQuery = { thumb64: true };
                _context.prev = 4;
                filter = {
                  where: whereForQuery,
                  fields: fieldsForQuery
                };
                _context.next = 8;
                return this.$api.get('TzbFs', filter);

              case 8:
                result = _context.sent;

                thumbFromDb = result[0];
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](4);

                console.log('setImageUrl: errore richiesta thumb');

              case 15:
                if (thumbFromDb && thumbFromDb.thumb64) {
                  if (this.imageThumb === thumbFromDb.thumb64) {
                    this.loadedThumb = true;
                  } else {
                    this.imageThumb = thumbFromDb.thumb64;
                  }
                }

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 12]]);
      }));

      function setImageUrl() {
        return _ref.apply(this, arguments);
      }

      return setImageUrl;
    }()
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011eaed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("MLRi");
function injectStyle (ssrContext) {
  __webpack_require__("isFg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011eaed4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MLRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"hero is-black is-fullheight"},[_c('div',{staticClass:"hero-body bg-img",style:(_vm.background)},[_c('div',{staticClass:"container has-text-centered"},[_c('a',{on:{"click":_vm.reset}},[_vm._m(0)]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag is-primary"},[_vm._v("Versione")]),_vm._v(" "),_c('span',{staticClass:"tag is-dark"},[_vm._v(_vm._s(_vm.info.version))])])])],1),_vm._v(" "),_c('div',{staticStyle:{"position":"fixed","right":"10px","bottom":"10px"}},[_c('span',{staticClass:"tag is-dark is-size-7",on:{"click":function($event){return _vm.randomize()}}},[_vm._v("cambia sfondo")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticStyle:{"margin-bottom":"60px"}},[_c('img',{attrs:{"src":__webpack_require__("kHqs"),"alt":"Logo cnos-fap","width":"220"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__("k5jX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__ = __webpack_require__("/KV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_auth__ = __webpack_require__("AQL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__("n5Qe");



var init = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_9__service_auth__["a" /* default */].checkAndRedirect();

          case 2:

            /* eslint-disable no-new */
            new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
              el: '#app',
              template: '<App/>',
              components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] },
              router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]
            });

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_buefy__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$api = __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].api;

init();

/***/ }),

/***/ "P7ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("QXXb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afa32ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("z+3g");
function injectStyle (ssrContext) {
  __webpack_require__("Pe7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7afa32ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afa32ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pe7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QXXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js__ = __webpack_require__("TBek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_config__ = __webpack_require__("2Dkn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_query__ = __webpack_require__("ZhQU");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import {
//   getSchools,
//   getWaitingList,
//   setWaitingList,
//   searchContactByCF,
//   getYearId,
// } from '@/service/tzb'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: this.$route.query.message,
      userRequest: {
        email: '',
        firstName: '',
        lastName: '',
        codiceFiscale: '',
        schoolId: '',
        school: {
          id: '',
          slug: ''
        },
        status: 'waiting',
        contactId: '',
        date: new Date()
      },
      schools: [],
      requestSent: null,
      validateInputs: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var year, yearSchools, filter, requested;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.userRequest.email = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].cookie.get('contactEmail');

              if (!(_this.message != null)) {
                _context.next = 14;
                break;
              }

              _context.next = 4;
              return _this.$api.getCustom('TzbTools', 'getYearId', {});

            case 4:
              year = _context.sent;
              _context.next = 7;
              return _this.$api.getById('TzbYears', year);

            case 7:
              yearSchools = _context.sent;

              _this.schools = yearSchools.schools;
              // const requested = await getWaitingList(this.userRequest.email)
              filter = {
                where: {
                  email: _this.userRequest.email,
                  status: 'waiting'
                }
              };
              _context.next = 12;
              return _this.$api.get('TzbWaitingUsersLists', filter);

            case 12:
              requested = _context.sent;

              _this.requestSent = requested.length > 0;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    cf: __WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js___default.a,
    gplusLogin: function gplusLogin() {
      var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_query__["a" /* parse */])(window.location.search),
          redirectTo = _parse.redirectTo;

      if (redirectTo) {
        redirectTo = window.location.href;
      } else {
        redirectTo = window.location.href + 'landing';
      }

      this.$cookie.set('redirectTo', redirectTo, {
        path: '/',
        domain: __WEBPACK_IMPORTED_MODULE_4__service_config__["d" /* COOKIE_DOMAIN */]
      });
      // Prendo l'API_URL e tolgo le ultime 3 lettere
      // ASSOLUTAMENTE da CAMBIARE!!!!
      var rootUrl = "https://api.tzb.cnosfap.net/v1".slice(0, -3);
      window.location.href = rootUrl + '/auth/google';
    },
    sendRequest: function sendRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isValid, filter, contacts, id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isValid = _this2.validate();

                console.log(isValid);

                if (!isValid) {
                  _context2.next = 14;
                  break;
                }

                // const contacts = await searchContactByCF(this.userRequest)
                filter = {
                  where: {
                    codiceFiscale: _this2.userRequest.codiceFiscale.toUpperCase()
                  }
                };
                _context2.next = 6;
                return _this2.$api.get('TzbContacts', filter);

              case 6:
                contacts = _context2.sent;

                if (contacts.length) {
                  id = contacts[0].id;

                  _this2.userRequest.contactId = id;
                  //          this.userRequest._contact = { id, nickname }
                }
                // console.log(contact) brgpgr74m19c722k
                _this2.userRequest.schoolId = _this2.userRequest.school.id;
                _context2.next = 11;
                return _this2.$api.put('TzbWaitingUsersLists', _this2.userRequest);

              case 11:
                // setWaitingList(this.userRequest)
                _this2.requestSent = true;
                _context2.next = 15;
                break;

              case 14:
                _this2.validateInputs = true;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    validate: function validate() {
      return this.userRequest.lastName.length >= 3 && this.userRequest.firstName.length >= 3 && this.userRequest.codiceFiscale.length === 16 && this.userRequest.school.id.length && __WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js___default.a.check(this.userRequest.codiceFiscale);
    },
    checkCF: function checkCF(codiceFiscale) {
      return __WEBPACK_IMPORTED_MODULE_3_codice_fiscale_js___default.a.check(codiceFiscale);
    }
  }
});

/***/ }),

/***/ "W3zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__("lta2");




var getContact = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(contactId) {
    var url, _ref2, data, contact, _ref3, _ref4, contactPreferences, yearId, schoolId, _ref5, _ref6, userAuth;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!contactId) {
              _context.next = 22;
              break;
            }

            url = 'TzbContacts/' + contactId;
            // url += '?filter[include]=contactPreferences'

            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get(url);

          case 4:
            _ref2 = _context.sent;
            data = _ref2.data;
            contact = data;
            _context.next = 9;
            return getUserPreferences({ contactId: contactId });

          case 9:
            _ref3 = _context.sent;
            _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 1);
            contactPreferences = _ref4[0];


            contact.contactPreferences = contactPreferences;

            yearId = contact.contactPreferences.defaultYear.id;
            schoolId = contact.contactPreferences.defaultSchool.id;
            _context.next = 17;
            return getUserAuths({ contactId: contactId, yearId: yearId, schoolId: schoolId });

          case 17:
            _ref5 = _context.sent;
            _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 1);
            userAuth = _ref6[0];

            contact.userAuth = userAuth;

            return _context.abrupt('return', contact);

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getContact(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getUserPreferences = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref8) {
    var contactId = _ref8.contactId;
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!contactId) {
              _context2.next = 7;
              break;
            }

            url = 'TzbUserPreferences';

            url += '?filter[where][contactId]=' + contactId;
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get(url);

          case 5:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getUserPreferences(_x2) {
    return _ref7.apply(this, arguments);
  };
}();

var getUserAuths = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref10) {
    var contactId = _ref10.contactId,
        yearId = _ref10.yearId,
        schoolId = _ref10.schoolId;
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!contactId) {
              _context3.next = 10;
              break;
            }

            url = 'TzbUserAuths';

            url += '?filter[where][contactId]=' + contactId;
            url += '&filter[where][yearId]=' + yearId;
            if (schoolId != null) {
              url += '&filter[where][schoolId]=' + schoolId;
            }
            url += '&filter[order]=_school.slug ASC';
            _context3.next = 8;
            return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get(url);

          case 8:
            response = _context3.sent;
            return _context3.abrupt('return', response.data);

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getUserAuths(_x3) {
    return _ref9.apply(this, arguments);
  };
}();

var updateContactPreferences = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(prefs) {
    var url;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = 'TzbUserPreferences' + (prefs.id ? '/' + prefs.id : '');
            _context4.next = 3;
            return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].put(url, prefs);

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function updateContactPreferences(_x4) {
    return _ref11.apply(this, arguments);
  };
}();



/* harmony default export */ __webpack_exports__["a"] = ({
  get: getContact,
  getAuths: getUserAuths,
  getPreferences: getUserPreferences,
  updatePreferences: updateContactPreferences
});

/***/ }),

/***/ "ZTRi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tzb-icon.06b6650.png";

/***/ }),

/***/ "ZhQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function parse(queryString) {
  var tokens = queryString.slice(1).split('&');
  return tokens.reduce(function (params, token) {
    var _token$split = token.split('='),
        _token$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_token$split, 2),
        key = _token$split2[0],
        value = _token$split2[1];

    params[key] = value;
    return params;
  }, {});
}

/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_auth__ = __webpack_require__("AQL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__("P7ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Landing__ = __webpack_require__("1CK9");






var options = {
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login__["a" /* default */]
  }, {
    path: '/landing',
    name: 'landing',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Landing__["a" /* default */]
  }]
};

var router = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */](options);

router.beforeEach(function (to, from, next) {
  if (to.name === 'login') {
    next();
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_1__service_auth__["a" /* default */].check()) {
    next({ name: 'login' });
    return;
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "isFg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kHqs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cnosfap5.99481b2.png";

/***/ }),

/***/ "lc7O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lta2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = authorize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2Dkn");




var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_URL */] });
/* harmony default export */ __webpack_exports__["a"] = (http);

function authorize(accessToken) {
  http.defaults.headers.common['Authorization'] = accessToken; // s`Bearer ${accessToken}`
}

// export function getSchoolPicture(school) {
//   return `${API_URL}/TzbFilesystems/schools/download/${school.slug}.jpg`
// }

/***/ }),

/***/ "n5Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_http__ = __webpack_require__("lta2");






var api = {};
/**
 * API GET generale
 * @function
 * @async
 * @todo Intercettare gli errori
 */
api.get = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(endpoint, filter) {
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/' + endpoint;

            url += '?filter=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter));
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].get(url);

          case 4:
            response = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return', response.data);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
api.getCustom = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(endpoint, methodName, parameters) {
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = endpoint + '/' + methodName + '?';

            if (parameters) {
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parameters).map(function (key) {
                url += key + '=' + parameters[key] + '&';
              });
              url = url.substring(0, url.length - 1);
            }
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].get(url);

          case 4:
            response = _context2.sent;

            if (!(response.status === 200)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt('return', response.data);

          case 7:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * API GetById generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} id - ricerca ID
 * @param {string} [filter] - Campi ES: {include: {id: true}}
 */
api.getById = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(endpoint, id, query) {
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!id) {
              _context3.next = 8;
              break;
            }

            url = '/' + endpoint + '/' + id;

            if (query) url += '?filter=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(query));
            _context3.next = 5;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].get(url);

          case 5:
            response = _context3.sent;

            if (!(response.status === 200)) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt('return', response.data);

          case 8:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * API PATCH generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.patch = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(endpoint, obj) {
    var query, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            query = '/' + endpoint + '/';
            _context4.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].patch(query, obj);

          case 3:
            response = _context4.sent;

            if (!(response.status === 200)) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt('return', response.data);

          case 6:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function (_x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * API PUT generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.put = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(endpoint, obj) {
    var query, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            query = endpoint;
            _context5.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].put(query, obj);

          case 3:
            response = _context5.sent;

            if (!(response.status === 200)) {
              _context5.next = 6;
              break;
            }

            return _context5.abrupt('return', response.data);

          case 6:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function (_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * API POST generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.post = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(endpoint, obj) {
    var query, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            query = endpoint;
            _context6.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].post(query, obj);

          case 3:
            response = _context6.sent;

            if (!(response.status === 200)) {
              _context6.next = 6;
              break;
            }

            return _context6.abrupt('return', response.data);

          case 6:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function (_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * API DELETE generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} id - ricerca ID
 */
api.delete = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(endpoint, id, where) {
    var query, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!where) where = {};else where = { where: where };
            query = '/' + endpoint;

            if (id) query += '/' + id;
            query += '?filter=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(where));
            _context7.next = 6;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].delete(query);

          case 6:
            response = _context7.sent;

            if (!(response.status === 200)) {
              _context7.next = 10;
              break;
            }

            if (response.data.count !== 0) console.log(response.data);
            return _context7.abrupt('return', response.data.count);

          case 10:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function (_x15, _x16, _x17) {
    return _ref7.apply(this, arguments);
  };
}();
api.deleteCustom = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(endpoint, methodName, parameters) {
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = endpoint + '/' + methodName + '?';

            if (parameters) {
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parameters).map(function (key) {
                url += key + '=' + parameters[key] + '&';
              });
              url = url.substring(0, url.length - 1);
            }
            _context8.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].delete(url);

          case 4:
            response = _context8.sent;

            if (!(response.status === 200)) {
              _context8.next = 7;
              break;
            }

            return _context8.abrupt('return', response.data);

          case 7:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function (_x18, _x19, _x20) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * API di conteggio degli Endpoint
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} [where] - Query di ricerca ES: {id:1}
 */
api.count = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(endpoint, where) {
    var url, response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = endpoint + '/count';

            if (where) url += '?where=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(where);
            _context9.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4__service_http__["a" /* default */].get(url);

          case 4:
            response = _context9.sent;

            if (!(response.status === 200)) {
              _context9.next = 7;
              break;
            }

            return _context9.abrupt('return', response.data.count);

          case 7:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function (_x21, _x22) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * API per richiamare un custom method
 * @function
 * @async
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} methodName - Il nome del methodo da richiamare: es. getPresence
 * @param {object} [parameters] - Parametri es. {courseId:123232c} o  oggetto:{dataToSend:{courseId: 1424141}
 */

/* harmony default export */ __webpack_exports__["a"] = ({ api: api });

/***/ }),

/***/ "pGQI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__("7YgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_auth__ = __webpack_require__("AQL0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      info: __WEBPACK_IMPORTED_MODULE_0__package_json___default.a,
      background: '',
      backgrounds: ['amsterdam', 'city-landscape', 'forest-water', 'forest', 'forest2', 'forest3', 'forest4', 'nature-raining', 'nature-sea', 'river', 'river2', 'sea', 'snow', 'miracle', 'cave-light', 'cityfog', 'mountain', 'cloudwaves']
    };
  },
  created: function created() {
    this.randomize();
  },


  methods: {
    randomize: function randomize() {
      var backgrounds = this.backgrounds;
      var select = backgrounds[Math.floor(Math.random() * backgrounds.length)];
      var style = 'background-image:url(../static/bg/' + select + '.gif)';
      this.background = style;
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_1__service_auth__["a" /* default */].logout();
      window.location.href = '/';
    }
  }
});

/***/ }),

/***/ "yiIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box shadow trasparent"},[_c('figure',{staticClass:"avatar"},[_c('avatar',{attrs:{"contactId":_vm.contact.id,"width":80,"height":80,"borderRadius":40}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"media shadow services",staticStyle:{"margin":"-5px 0px 20px 0px"}},[_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"content",staticStyle:{"padding":"5px"}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.contact.nickname))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contact._emails && _vm.contact._emails[0])?_c('small',{staticClass:"is-size-7"},[_vm._v(_vm._s(_vm.contact._emails[0].email))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"media-right",staticStyle:{"padding":"12px"}},[_c('a',{staticClass:"button is-danger is-outlined",on:{"click":function($event){return _vm.logout()}}},[_vm._v("Esci")])])]),_vm._v(" "),_vm._l((_vm.services),function(service){return _c('div',{key:service.name},[_c('article',{staticClass:"media shadow services",class:_vm.serviceClass(service),on:{"click":function($event){return _vm.gotoUrl(service, service.url)}}},[_c('figure',{staticClass:"media-left"},[_c('p',{staticClass:"image is-64x64"},[_c('img',{attrs:{"src":service.image,"alt":"Placeholder image"}})])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"content"},[_c('strong',[_vm._v(_vm._s(service.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(service.subtitle))])])])])])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z+3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box shadow trasparent"},[_vm._m(0),_vm._v(" "),_c('div',[(_vm.message === 'per adesso lascia stare')?_c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body",staticStyle:{"margin-top":"3px","padding":"0px"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n        "),_c('span',{staticClass:"is-pulled-right",staticStyle:{"padding":"4px"}},[_c('button',{staticClass:"delete is-small",attrs:{"aria-label":"delete"},on:{"click":function($event){_vm.message = null}}})])])]):_vm._e(),_vm._v(" "),(_vm.message != null)?_c('section',[(_vm.requestSent)?_c('section',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.requestSent === false)?_c('section',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label is-pulled-left"},[_vm._v("Nome")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userRequest.firstName),expression:"userRequest.firstName"}],staticClass:"input",class:{'is-danger': _vm.userRequest.firstName.length<3},attrs:{"type":"text","placeholder":"Esempio: Giovanni"},domProps:{"value":(_vm.userRequest.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userRequest, "firstName", $event.target.value)}}})]),_vm._v(" "),(_vm.userRequest.firstName.length < 3 && _vm.validateInputs)?_c('p',{staticClass:"help is-danger"},[_vm._v("Inserire almeno 3 lettere")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label is-pulled-left"},[_vm._v("Cognome")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userRequest.lastName),expression:"userRequest.lastName"}],staticClass:"input",class:{'is-danger': _vm.userRequest.lastName.length<3},attrs:{"type":"text","placeholder":"Esempio: Bosco"},domProps:{"value":(_vm.userRequest.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userRequest, "lastName", $event.target.value)}}})]),_vm._v(" "),(_vm.userRequest.lastName.length < 3 && _vm.validateInputs)?_c('p',{staticClass:"help is-danger"},[_vm._v("Inserire almeno 3 lettere")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label is-pulled-left"},[_vm._v("Codice Fiscale")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userRequest.codiceFiscale),expression:"userRequest.codiceFiscale"}],staticClass:"input",class:{'is-danger': _vm.userRequest.codiceFiscale.length!=16, 'is-success': _vm.userRequest.codiceFiscale.lengt==16},attrs:{"type":"text","placeholder":"Esempio GVNBSC15M19C722K"},domProps:{"value":(_vm.userRequest.codiceFiscale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userRequest, "codiceFiscale", $event.target.value)}}})]),_vm._v(" "),(!_vm.checkCF(_vm.userRequest.codiceFiscale) && _vm.validateInputs)?_c('p',{staticClass:"help is-danger"},[_vm._v("Controllare la validità")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label is-pulled-left",staticStyle:{"margin-right":"50px"}},[_vm._v("Centro")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userRequest.school),expression:"userRequest.school"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userRequest, "school", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.schools),function(school){return _c('option',{key:school.id,domProps:{"value":school}},[_vm._v(_vm._s(school.slug))])}),0)])]),_vm._v(" "),(_vm.userRequest.school.id === '' && _vm.validateInputs)?_c('p',{staticClass:"help is-danger"},[_vm._v("Selezionare un valore")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"button is-primary is-medium is-block",on:{"click":function($event){return _vm.sendRequest()}}},[_c('span',[_vm._v("Invia")])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.message == null)?_c('section',[_c('a',{staticClass:"button is-primary is-medium is-block",on:{"click":function($event){return _vm.gplusLogin()}}},[_vm._m(3),_vm._v(" "),_c('span',[_vm._v("Google @cnosfap.net")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"avatar"},[_c('img',{staticStyle:{"width":"80px"},attrs:{"src":__webpack_require__("ZTRi"),"alt":"Logo cnos-fap"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body",staticStyle:{"margin-top":"3px","padding":"0px"}},[_vm._v("\n            La richiesta è stata registrata.\n            "),_c('br'),_vm._v("Presto tale richiesta verrà analizzata dal personale autorizzato.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body",staticStyle:{"margin-top":"3px","padding":"0px"}},[_vm._v("\n            Nessun utente trovato con questa email.\n            "),_c('br'),_vm._v("Se intendi utilizzare questa email per il login, compila i dati e attendi l'autorizzazione\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-danger is-medium is-block",attrs:{"disabled":""}},[_c('span',[_vm._v("Google login")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-info is-medium is-block",attrs:{"disabled":""}},[_c('span',[_vm._v("Facebook login")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"has-text-black",staticStyle:{"margin-top":"20px"}},[_c('a',{attrs:{"href":"http://extranet.cnosfap.net/accesso.php"}},[_c('strong',[_vm._v("Accesso collaboratori")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9e694bfddf29eadd9c27.js